import { requester } from "../utils";

export const getAllAds = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/ad/app`,
        method: "GET",
        withAuth: false,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get ads error", err);
        reject(err);
      });
  });
};